// auto-generated by Typewriter template _models.tst from PortCall.Pilots.EndPoints\Api\AgencyCode\ApiAgencyCode.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { Organization, OrganizationData, OrganizationOptions } from 'data/models/Organization';
import { PilotAgency, PilotAgencyData, PilotAgencyOptions } from 'data/models/PilotAgency';

// AgencyCodeData is the class that AgencyCode serializes to/from
export interface AgencyCodeData {
    CodedOrganizationId : number;
    PilotAgencyId : number;
    Url : string | null;
	
    CodedOrganization : OrganizationData | null;
    PilotAgency : PilotAgencyData | null;
	
    Code : string;
}

// AgencyCodeOptions is the class which may be passed to the AgencyCode constructor to define optional initial data values
export interface AgencyCodeOptions {
    CodedOrganizationId : number;
    PilotAgencyId : number;
    Url? : string | null;
	
    CodedOrganization? : OrganizationOptions | null;
    PilotAgency? : PilotAgencyOptions | null;
	
    Code? : string;
}

export class AgencyCode {
    public CodedOrganizationId : DataSignal<number>;
    public PilotAgencyId : DataSignal<number>;
    public Url : DataSignal<string | null>;
	
    public CodedOrganization : DataSignal<Organization | null>;
    public PilotAgency : DataSignal<PilotAgency | null>;
	
    public Code : DataSignal<string>;

    constructor();
    constructor(data : AgencyCodeOptions);
    constructor(data: AgencyCodeOptions | null = null) {
        this.CodedOrganizationId = jsonableObservable(S.value<number>(data && data.CodedOrganizationId !== undefined ? data.CodedOrganizationId : 0));
        this.PilotAgencyId = jsonableObservable(S.value<number>(data && data.PilotAgencyId !== undefined ? data.PilotAgencyId : 0));
        this.Url = jsonableObservable(S.value<string | null>(data && data.Url !== undefined ? data.Url : null));
	    
        this.CodedOrganization = S.value<Organization | null>(null);
        this.PilotAgency = S.value<PilotAgency | null>(null);
	    
        this.Code = jsonableObservable(S.value<string>(data && data.Code !== undefined ? data.Code : ''));
    }

    static key(obj : AgencyCode) {
        return obj.CodedOrganizationId() + '\u2618' + obj.PilotAgencyId();
    }
    
    static dataKey(obj : AgencyCodeOptions) {
        return obj.CodedOrganizationId + '\u2618' + obj.PilotAgencyId;
    }

    static update(obj : AgencyCode, data : AgencyCodeOptions) {
        S.freeze(() => {
            if (data.CodedOrganizationId !== undefined) obj.CodedOrganizationId(data.CodedOrganizationId);
            if (data.PilotAgencyId !== undefined) obj.PilotAgencyId(data.PilotAgencyId);
            if (data.Url !== undefined) obj.Url(data.Url);
	        
	        
            if (data.Code !== undefined) obj.Code(data.Code);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/AgencyCode.ts